/**
 * Markdown content pages - Education, History, Contributors
 */
import React from "react";
import Container from "./../components/core/Container";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import EduSidebar from "../components/education/EducationSidebar.js";
import CoreBanner from "./../components/core/CoreBanner";

import approach from "../markdown/overview.js";
import bodycontact from "../markdown/bodycontact.js";
import history from "../markdown/history.js";
import contributors from "../markdown/contributors.js";
import skills from "../markdown/skills.js";
import injuryPrevention from "../markdown/injuryprevention.js";
import camps from "../markdown/camps.js";
import { Helmet } from "react-helmet-async";
import gdpr from "../markdown/gdpr.js";
import PageSidebarContainer from "../components/core/PageSidebarContainer";
import ContentContainer from "../components/core/ContentContainer";

const articles = [
  {
    name: "approach",
    sidebar: "education",
    mdcontent: approach,
    banner: true,
    title: "Program Overview",
  },
  {
    name: "bodycontact",
    sidebar: "education",
    mdcontent: bodycontact,
    banner: true,
    title: "Body Contact",
  },
  {
    name: "history",
    sidebar: "education",
    mdcontent: history,
    banner: true,
    title: "History",
  },
  {
    name: "contributors",
    sidebar: "education",
    mdcontent: contributors,
    banner: true,
    title: "Contributors",
  },
  {
    name: "skills",
    sidebar: "education",
    mdcontent: skills,
    banner: true,
    title: "Skills Development",
  },
  {
    name: "injury-prevention",
    sidebar: "education",
    mdcontent: injuryPrevention,
    banner: true,
    title: "Injury Prevention",
  },
  {
    name: "camps",
    sidebar: "education",
    mdcontent: camps,
    banner: true,
    title: "BUIHA Training Camps",
  },
  {
    name: "gdpr",
    sidebar: "education",
    mdcontent: gdpr,
    banner: false,
    title: "GDPR Statement",
  },
];

// Only BUIHA should have access to this
const enableTables = true;

const Mdcontent = ({ mdfile }) => {
  let data = articles.find((article) => article.name === mdfile);

  return (
    <>
      <Helmet>
        <title>
          {data.mdcontent.title} | BUIHA{" "}
          {data.sidebar === "education" ? "Education" : ""}
        </title>
        <meta name="description" content={data.mdcontent.title} />
        <link rel="canonical" href={`https://buiha.org/${data.name}`} />
        <link rel="icon" type="image/png" href="/favicon.png" />
      </Helmet>
      <link
        href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&family=Roboto:wght@400;500;700&family=Source+Sans+Pro:wght@400;600;700&family=Lato:wght@400;700&family=Noto+Sans:wght@400;600;700&family=PT+Sans:wght@400;700&display=swap"
        rel="stylesheet"
      ></link>

      {data.banner && <CoreBanner title={data.mdcontent.title} />}
      <Container
        children={
          <PageSidebarContainer
            children={
              <>
                <ContentContainer
                  children={
                    <ReactMarkdown
                      className="prose"
                      children={data.mdcontent.mdcontent}
                      remarkPlugins={enableTables ? [remarkGfm] : []}
                    />
                  }
                  extraClasses={"mt-[4px]"}
                />
                {
                  // if data.sidebar === education
                  data.sidebar === "education" && <EduSidebar />
                }
              </>
            }
          />
        }
      />
    </>
  );
};

export default Mdcontent;
